import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.courseApplyController;
const getCourseApply = self.customSetting.getCourseApply;
const postCourseApply = self.customSetting.postCourseApply;

export default {
  qryCourseList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getCourseApply}/QryCourseList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryCoursePeople: (context, Course_Id) => {
    return axios.get(
      `${baseApi}/${getCourseApply}/QryCoursePeople?Course_Id=${Course_Id}`
    );
  },
  cancelSignUpList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getCourseApply}/CancelSignUpList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  saveCoursePeople: (context, data) => {
    return axios.post(`${baseApi}/${postCourseApply}/SaveCoursePeople`, data);
  },
  updCancelSignUp: (context, data) => {
    return axios.post(`${baseApi}/${postCourseApply}/UpdCancelSignUp`, data);
  },
};
